﻿window.cCadencementEnvoi = function(dataCom) {
    var txt = ""

    if (dataCom.date_debut_envoi != null) {
        txt = "Début envois: <span style='opacity:0.5;'>" + dataCom.date_debut_envoi.toFrenchDateTime() + "</span>"
    } else {
        txt = "Début envois: <span style='opacity:0.5;'>Immédiat</span>"
    }

    if (dataCom.jour_envoi != null && dataCom.jour_envoi.length>0) {
        txt += ((txt.length > 0) ? " &bull; " : "") + "Jours envois: <span style='opacity:0.5;'>" +  dataCom.jour_envoi.remplacerTout("|",",") + "</span>"
    }

    if (dataCom.hors_jours_feries == "1") {
        txt += ((txt.length > 0) ? " &bull; " : "") + "<span style='opacity:0.5;'>Hors jours fériés</span>"
    }

    if (dataCom.horaire_envoi != null && dataCom.horaire_envoi.length>0) {
        txt += ((txt.length > 0) ? " &bull; " : "") + "Horaires: <span style='opacity:0.5;'>" + dataCom.horaire_envoi.remplacerTout("||", ",").remplacerTout("|", "-") + "</span>"

    }

    if (dataCom.tempo_envoi_nb_msg != null && dataCom.tempo_envoi_nb_msg != 0 && dataCom.tempo_envoi_sec != null && dataCom.tempo_envoi_sec!=0) {
        txt += ((txt.length > 0) ? " &bull; " : "") + "<span style='opacity:0.5;'>Envoi " + dataCom.tempo_envoi_nb_msg + " msgs toutes les " + dataCom.tempo_envoi_sec + " s</span>"
    }

    this.mGetLibelle = function () { return txt }

}